import { ComponentProps, FC } from 'react'
import { QuotaType } from '@bpinternal/const'
import {
  BuildingIcon,
  CircleQuestionMarkIcon,
  DatabaseIcon,
  FileIcon,
  Grid2x2PlusIcon,
  LightbulbIcon,
  MessageSquareTextIcon,
  Repeat2Icon,
  TableIcon,
  TriangleAlertIcon,
  UsersIcon,
  ZapIcon,
} from 'lucide-react'

type Props = {
  quota?: QuotaType | 'team' | 'plus'
} & ReactIconProps

type ReactIconProps = ComponentProps<typeof Repeat2Icon>

const icon: Record<QuotaType | 'team' | 'plus', FC<ReactIconProps>> = {
  table_row_count: TableIcon,
  knowledgebase_vector_storage: DatabaseIcon,
  storage_count: FileIcon,
  workspace_member_count: UsersIcon,
  always_alive: ZapIcon,
  invocation_calls: MessageSquareTextIcon,
  bot_count: Grid2x2PlusIcon,
  team: BuildingIcon,
  plus: LightbulbIcon,

  //NOT IMPLEMENTED
  ai_spend: CircleQuestionMarkIcon,
  bing_search_spend: CircleQuestionMarkIcon,
  integrations_owned_count: CircleQuestionMarkIcon,
  invocation_timeout: CircleQuestionMarkIcon,
  openai_spend: CircleQuestionMarkIcon,
  workspace_ratelimit: CircleQuestionMarkIcon,
}

export const ProductIcon = ({ quota, ...props }: Props) => {
  const Icon = quota ? icon[quota] : null

  return Icon ? <Icon {...props} /> : <TriangleAlertIcon {...props} />
}
